function partners() {
    $('[data-box="partnerForm"]').click((e) => {
        const packageLevel = e.currentTarget.dataset.value;
        $('#level').val(`${packageLevel}`);
        $('.input-container').show();
    });

    $('.partner-form input[name="phone"]').mask('(000) 000-0000');

    // contact form
    $('.partner-form').validate();

    $('.partner-form').submit((e) => {
        e.preventDefault();

        if ($('.partner-form').valid()) {
            // triggers submitContact if valid
            grecaptcha.execute(); // eslint-disable-line no-undef
        }
    });
}

export { partners };
